export default "__VITE_ASSET__5aQ3mG1h__"